<div>
    <h1 [innerHTML]="granteeAuthorizationAgreement.heading" class="c11n-text-xl-headline c11n-space-stack-3x"></h1>
    <div [innerHTML]="granteeAuthorizationAgreement.text1" class="authorization-body"></div>
</div>
